module.exports = __webpack_public_path__ + "static/media/sportgala.095aa208.jpg";